export default [
    {
        name: 'Blue Gnome',
        ID: 1,
    },
    {
        name: 'Green Gnome',
        ID: 2,
    },
    {
        name: 'Yellow Gnome',
        ID: 3,
    },
    {
        name: 'Orange Gnome',
        ID: 4,
    },
    {
        name: 'Peasant Lady',
        ID: 5,
    },
    {
        name: 'Gnome Mates',
        ID: 6,
    },
    {
        name: 'Sexy Gnome',
        ID: 7,
    },
];
